<div class="si-breadcrumb d-flex" *ngIf="showBreadcrumbs">
  <div *ngFor="let item of breadcrumbs; first as isFirst" class="si-breadcrumb_item">
    <span *ngIf="!isFirst">&nbsp;|&nbsp;</span>
    <a [routerLink]="item.url">{{item.label | translate}}</a>
  </div>
</div>
